<template>
  <div ref="SalesReceipt" class="d-none">
    <div class="white-wrapper mt-4">
      <table style="border: 1px solid #000000; max-width: 320px; font-size: 11px;">
        <thead>
          <tr>
            <th colspan="5" style="text-align: left;">
              <div>{{bookingDetails.cine_name}}</div>
              <div>{{bookingDetails.cine_phone}}</div>
              <div>Pin No: P051359115A</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr style="border-bottom-style: dashed;">
            <td colspan="3">
              <div class="font-weight-bold">Sales Receipt</div>
              <div>{{ currentDate }}</div>
            </td>
            <td
              colspan="2"
              style="vertical-align: bottom;"
            >Transaction No: {{ bookingDetails.sb_booking_code }}</td>
          </tr>
          <tr>
            <td colspan="5" style="border-bottom: 1px dashed #000"></td>
          </tr>
          <tr style="border-bottom: 1px dashed #000000">
            <td>Qty</td>
            <td>Description</td>
            <td>Price</td>
            <td>Tax</td>
            <td>Total</td>
          </tr>
          <tr>
            <td colspan="5" style="border-bottom: 1px dashed #000"></td>
          </tr>
          <tr>
            <td colspan="5" style="font-weight: bold;">Tickets</td>
          </tr>
          <tr>
            <td>{{ bookingDetails["seats_types"] ? bookingDetails["seats_types"].length : '' }}</td>
            <td>
              {{ bookingDetails.movie_title }}-{{bookingDetails.mf_name}}-{{bookingDetails.lang_name}}
              <span
                v-for="(seatType, seatTypeIndex) in bookingDetails.uniqueSeatTypes"
                :key="seatTypeIndex"
              >
                ({{bookingDetails.screen_name}}:
                <span>{{seatType}} - {{bookingDetails.seats}}</span>
                <span v-if="seatTypeIndex + 1 < bookingDetails.uniqueSeatTypes.length">,</span>)
              </span>
              {{ bookingDetails.og_show_date | dateparse }} {{ bookingDetails.og_show_time | timeparseAmPm }}
            </td>
            <td>{{ netAmount.toFixed(this.MIN_FRACTION_DIGITS) }}</td>
            <td>
              <span>{{ getTaxAmount.toFixed(this.MIN_FRACTION_DIGITS) }}</span>
            </td>
            <td>{{ tickettotal }}</td>
          </tr>
          <tr>
            <td colspan="5" style="border-bottom: 1px dashed #000"></td>
          </tr>
          <tr>
            <td colspan="5" style="text-align: right">Amount Due: {{getcurrency}} {{ tickettotal }}</td>
          </tr>
          <tr
            v-if="getSelectedOffer && getSelectedOffer.offer_print_on_ticket == 'Y' || offerFor == 'vouchers'"
            style="border-bottom: 1px dashed #000000"
          >
            <td colspan="2" style="text-align: left;">
              <div style="font-weight: bold;">Discount</div>
              {{ getSelectedOffer.offer_title || getSelectedOffer.voucher_title }}
            </td>
            <td
              colspan="3"
              style="text-align: right; vertical-align: bottom"
            >{{ getcurrency }} {{ offerPrice }}</td>
          </tr>
          <tr>
            <td colspan="5" style="border-bottom: 1px dashed #000"></td>
          </tr>
          <tr style="border-bottom: 1px dashed #000000">
            <td colspan="2" style="text-align: left;">
              <div style="font-weight: bold;">Payment Mode</div>
              {{ paymentDetails.pm_payment_mode }}
            </td>
            <td
              colspan="3"
              style="text-align: right; vertical-align: bottom"
            >{{getcurrency}} {{ totalAmount }}</td>
          </tr>
          <tr>
            <td colspan="5" style="border-bottom: 1px dashed #000"></td>
          </tr>
          <tr>
            <td colspan="5" style="text-align: center">Tax breakdown</td>
          </tr>
          <tr style="border-bottom: 1px dashed #000000; text-align: center;">
            <td style="width: 25%;">Rate %</td>
            <td style="width: 25%;">Net</td>
            <td style="width: 25%;">Tax</td>
            <td colspan="2" style="width: 25%;">Total</td>
          </tr>
          <tr>
            <td colspan="5" style="border-bottom: 1px dashed #000"></td>
          </tr>
          <tr style="border-bottom: 1px dashed #000000; text-align: center;">
            <td style="width: 25%;">
              <div>{{ getTaxesNames }}</div>
            </td>
            <td style="width: 25%;">
              <div>{{ netAmount.toFixed(this.MIN_FRACTION_DIGITS) }}</div>
            </td>
            <td style="width: 25%;">
              <div>{{ getTaxAmount.toFixed(this.MIN_FRACTION_DIGITS) }}</div>
            </td>
            <td colspan="2" style="width: 25%;">
              <div>{{getcurrency}} {{ totalAmount }}</div>
            </td>
          </tr>
          <tr>
            <td colspan="5" style="border-bottom: 1px dashed #000"></td>
          </tr>
          <tr>
            <td colspan="5">
              <div>Sold By: {{ name }}</div>
              <div>Sold on: {{ hardwarename && hardwarename.length > 0 ? hardwarename : '-' }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Printd from "printd";
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import moment from "moment";
import { EventBus } from "@/main";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      currentDate: "",
      TaxAmountValue: "",
      name: "",
      pos_hardware_name: ""
    };
  },
  computed: {
    offerFor() {
      return this.$store.getters.getOfferFor;
    },
    getSelectedOffer() {
      return this.$store.getters.getSelectedOffer;toString
    },
    offerPrice() {
      return this.getOfferPrice ? parseFloat(this.getOfferPrice).toFixed(this.MIN_FRACTION_DIGITS) : 0;
    },
    paymentDetails() {
      return this.$store.getters.selectedPaymentMode;
    },
    bookingDetails() {
      return this.$store.getters.BOOKING_DETAILS;
    },
    AdditionalCharges() {
      return this.$store.getters.ADDITIONAL_CHARGES;
    },
    getcurrency() {
      return this.$store.getters.GET_CURRENCY;
    },
    netAmount() {
      return this.$store.getters.NET_AMOUNT;
    },
    getSelectedArray() {
      let array = [];
      if (
        this.bookingDetails &&
        this.bookingDetails["seats_types"] &&
        this.bookingDetails["seats_types"].length > 0
      ) {
        this.bookingDetails.seats_types.map(x => {
          x.seats.map(y => {
            array.push({
              seatName: y,
              seatType: x.seat_type
            });
          });
        });
      }
      return array;
    },
    getTaxesNames() {
      let taxName = [];
      if (this.AdditionalCharges && this.AdditionalCharges.length > 0) {
        this.AdditionalCharges.forEach(e => {
          taxName.push(e.charge_type_name);
        });
        return taxName.toString();
      } else {
        return "No Charges";
      }
    },
    getTaxAmount() {
      let TaxValue = null;

      console.log("this.AdditionalCharges :", this.AdditionalCharges);
      if (this.AdditionalCharges && this.AdditionalCharges.length > 0) {
        this.AdditionalCharges.forEach(e => {
          TaxValue += e.sp_value;
        });
        return TaxValue;
      } else {
        return (TaxValue = 0.0);
      }
    },
    getTotal() {
      let Total = null;

      Total = this.netAmount + this.getTaxAmount;
      return Total;
    },
    totalAmount() {
      return this.getOfferPrice > 0
        ? this.$store.getters.TOTAL_AMOUNT - this.getOfferPrice
        : this.$store.getters.TOTAL_AMOUNT;
    },
    tickettotal() {
      return this.$store.getters.TOTAL_AMOUNT;
    },
    hardwarename() {
      return this.$store.getters.gethardwarename;
    },
    ...mapGetters(["getOfferPrice", "getSelectedOffer", "getOfferFor"])
  },
  beforeMount() {
    this.currentDate = moment().format("DD/MM/YY HH:mm");
    const { cinema_id } = this.secureStore.get("USINFO");
    this.name = this.secureStore.get("USINFO").first_name;
  },
  mounted() {
    EventBus.$on("printSalesReceipt", () => {
      this.print();
    });
  },
  methods: {
    print: function() {
      const p = new Printd();
      p.print(this.$refs.SalesReceipt, []);
    }
  }
};
</script>

<style>
table,
td,
th {
  padding: 8px;
}
</style>
 





// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/sales_receipts.vue